import domain from '@/server-config/domain.config'
import { $http } from '../request'

/** ------------- Node 缓存接口 -------------------- */

/** ------------- Node 缓存接口 -------------------- */

/** Client API：获取热门类目 */
export const getHotFrontCtgs = async(): Promise<ICategory[]> => {
  if(!useGlobalJsonData().value?.hot_categories) {
    return []
  }
  
  const { version, obsUrl  } = useGlobalJsonData().value?.hot_categories
  const v = localStorage.getItem('home_hot_categories_timestamp')
  let cacheData = localStorage.getItem('home_hot_categories')

  if(!cacheData || String(version) !== v) {
    const res = await $http.get({ url: `${obsUrl}?t=${version}`, server: false }).then((r: any) => r.data.subs)
    
    cacheData = JSON.stringify(res)
    localStorage.setItem('home_hot_categories', cacheData)
    localStorage.setItem('home_hot_categories_timestamp', version)
  }

  return JSON.parse(cacheData)
}

export const getFrontCtgs = async(): Promise<ICategory[]> => {
  const { front_categories } = useGlobalJsonData().value

  const ctgTimestamp = localStorage.getItem('categories_timestamp')
  const ctgCache = localStorage.getItem('pc__home_categories')

  // 覆盖服务端渲染数据，在客户端渲染完整节点
  if(front_categories) {
    const { version, obsUrl } = front_categories

    const frontCategoriesUrl = `${obsUrl}?t=${version}`

    if(!ctgCache || !ctgTimestamp || Number(ctgTimestamp) !== version) {
      try {
        const newFrontCtgs = await $http.get({ url: frontCategoriesUrl, baseURL: domain.EBES_B2C_AWS_S3_MEDIA, loading: false }).then((r: any) => r?.data?.subs || [])

        localStorage.setItem('categories_timestamp', version)
        localStorage.setItem('pc__home_categories', JSON.stringify(newFrontCtgs || '[]'))

        return newFrontCtgs
      } catch(e) {
        console.error("前台品类获取失败:", e)
        
        return JSON.parse(ctgCache || '[]')
      }
    } else {
      return JSON.parse(ctgCache || '[]')
    }
  }
  
  return JSON.parse(ctgCache || '[]')
}

/** 获取首页配置JSON */
export const getHomeConfig = () => $http.get({
  baseURL: '/',
  url: '/api/home/home-cms',
  params: { _t: Date.now() },
  server: true
}).then((r: any) => r.data)

/** 获取首页Tab栏数据 */
export const getTags = async () => {
  return $http.get({
    url: '/navi/tags'
  })
}

/** 切换Tab栏获取商品数据 */
interface TAB_GOODS_REQ {
  /** tag栏Id */
  tagId: string | number,
  /** 最后一个商品ID，第一页可传递-1 */
  goodsId: number,
  /** 查询数量 */
  size: number
}
export const getTagsListing = (params: TAB_GOODS_REQ) => {
  return $http.get({
    url: `/navi/tags/${params.tagId}/listings?lastId=${params.goodsId}&limit=${params.size}`
  })
}

/** 秒杀 */
export const getFlashSale = () => {
  return $http.get({
    url: '/flash-sales/now'
  })
}

/** 新品 */
export const getNewArrival = () => {
  return $http.get({
    url: '/listings/new-arrival?lastId=-1&limit=20'
  })
}

/** 推荐 */
export const getRecommended = (rid: number, params: IPayload, skus?: number[], clsId?: number, excludeListings?: number[]) => {
  let skuIds: string = '' 
  if(skus?.length) {
    skuIds = skus.map((id: number) => `skuIds=${id}`).join('&')
  }
  let excludeListingIds: string = ''
  if(excludeListings?.length) {
    excludeListingIds = excludeListings.map((id: number) => `excludeListingIds=${id}`).join('&')
  }
  if (clsId) {
    params.categoryIds = clsId
  }
  const queryParts = [skuIds, excludeListingIds].filter(Boolean).join('&')
  return $http.get({
    url: `/recommended/${rid}?${queryParts}`,
    params: params
  })
}